import { React, useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Banner from "../Components/Banner";
import AOS from "aos";
import Howitworks from "../Components/Industries/Howitworks";
import Whyus from "../Card-Components/Whyus";
import Tools from "../Components/Industries/Tools";
import Chatwithus from "../Components/chatwithus";
import Button from "../Components/Button";
import FormModal from '../Components/FormModal';



//images
import Industries_banner from "../images/banner_images/laptop/industries.png"
import mobindustriesbanner from '../images/banner_images/mobile/mobile_industries.png'
import consultation_icon from '../images/Industries/consultation_icon.png'
import execution_icon from '../images/Industries/Execution_icon.png'
import dealclose_icon from '../images/Industries/dealclose_icon.png'
import ecommerce from '../images/Industries/ecommerce.png'
import retail from '../images/Industries/Retail.png'
import manufacturing from '../images/Industries/Manufacturing.png'
import pharmaceuticals from '../images/Industries/pharmaceuticals.png'
import food from '../images/Industries/food.png'
import automative from '../images/Industries/automative.png'
import apparel from '../images/Industries/apparel.png'
import google_logo from '../images/liaison/Google-Review-Logo 1.png'
import industrial_logistics from '../images/Industries/industrial_logistics.png'
import commercial from '../images/Industries/Commercial.png'
import development from '../images/Industries/Development.png'
import energy from '../images/Industries/Energy.png'

import logistics from '../images/Industries/Logistics.png'
import acquisiton from "../images/Industries/acquisition.png"
import aggregation from "../images/Industries/aggregation.png"
// import renovation from "../images/Industries/renovation.png"
import IT from "../images/Industries/IT.png"
import Retail from "../images/Industries/Retail.png"
import Logistics from "../images/Industries/Logistics.png"
// import commercial from "../images/Industries/Commercial.png"
import Development from "../images/Industries/Development.png"
import Energy from "../images/Industries/Energy.png"
import Manufacturing from "../images/Industries/Manufacturing.png"
import Hospital from "../images/Industries/Hospital.png"

// import work from "../images/Industries/Why-work.png"
import TestimonialSlider from "../Components/testimonial_slider";
import { hasFormSubmit } from "@testing-library/user-event/dist/utils";
import Testimonial from "../Components/Testimonials";


function B2B() {

    // Modal State & Function
    const [modalToggle, setModalToggle] = useState(false);
    function toggle() {
        setModalToggle(!modalToggle);
    }

    const featuredService = [
        {
            icon: consultation_icon,
            alt: "consultation icon",
            heading: "Consultation",
            content: "Tailored advice to match your property needs, from market insights to the right location."
        },
        {
            icon: execution_icon,
            alt: "execution icon",
            heading: "Execution",
            content: "We source and match properties that align with your goals, ensuring value and efficiency at every step."
        },
        {
            icon: dealclose_icon,
            alt: "Dealclose icon",
            heading: "Deal Closure",
            content: "Negotiation, legal compliance, and documentation-  handled quickly to secure the best terms for you."
        },

    ]

    const industries_serve = [
        // {
        //     icon : ecommerce,
        //     alt : "ecommerce icon",
        //     heading : "E-Commerce",
        //     link : "#"
        // },
        // {
        //     icon : Manufacturing,
        //     alt : "Manufacturing icon",
        //     heading : "Manufacturing",
        //     link : "/industries/manufacturing"
        // },
        {
            icon: retail,
            alt: "Retail icon",
            heading: "Retail",
            link: "/industries/retail"
        },

        {
            icon: commercial,
            alt: "commercial",
            heading: "Commercial",
            link: "/industries/commercial"
        },
        {
            icon: development,
            alt: "Development",
            heading: "Development",
            link: "/industries/development"
        },
        {
            icon: IT,
            alt: "IT",
            heading: "IT",
            link: "/industries/it"
        },
        {
            icon: energy,
            alt: "Energy",
            heading: "Energy",
            link: "/industries/energy"
        },
        {
            icon: Logistics,
            alt: "Logistics icon",
            heading: "Logistics",
            link: "/industries/logistics"
        },

    ]

    const params = useParams();
    console.log(params);

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    const handleTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    };


    return (
        <>
            <Banner
                img={Industries_banner}
                mimg={mobindustriesbanner}
                heading={"Acquisition. Approvals. Everything in between."}
                subheading={"Seamless approvals, precise delivery, clear visibility at every stage"}
                textposition={"w-[85%] bottom-8 left-8 right-8 lg:w-[675px] lg:bottom-[100px] lg:left-[100px]"}
                renderButton={() =>(
                    <Button name={"Explore our Services"} design={"filled"} action={"scroll"} section_id={"industry-services"} />
                )}
            />

            <div className='max-w-[846px] mx-auto my-[60px] px-4 sm:my-[100px]'>
                <h1 className='heading' data-aos="fade-up">Industries</h1>
                <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[25px]' data-aos="fade-up" data-aos-duration="800"/>
                <p className="service-description max-w-[846px] mx-auto" data-aos="fade-up" data-aos-duration="1100">From land acquisition to ready-to-use spaces, we deliver real estate solutions built around your business. Property search, negotiation, deal closure, legal compliance, registration, and approvals — handled seamlessly under one roof. You grow your business. We take care of the property details.</p>
            </div>

            {/* Featured Services  */}

            <div className="max-w-[1210px] mx-auto">
                <div>
                    <h1 className='heading' data-aos="fade-up">Our Featured Services</h1>
                    <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[35px]' data-aos="fade-up" data-aos-duration="1100"/>
                </div>

                {/* Looping Card */}
                <div className="flex flex-wrap justify-center gap-8 mt-[62px] px-4 lg:px-0">

                    {
                        featuredService.map((items) => {

                            return (

                                <div className="w-[382px] h-fit mx-auto bg-grey p-[40px] sm:h-[431px] md:mx-0" data-aos="fade-up">
                                    <img className="w-[65px]" src={items.icon} alt={items.alt} />
                                    <h1 className="font-noto text-[26px] font-bold leading-[40px] mt-[20px] lg:text-[32px] lg:mt-[38px]">{items.heading}</h1>
                                    <p className="font-alibaba text-[#5F5D5E] text-[18px] leading-[30px] mt-[25px] sm:text-[20px]">{items.content}</p>
                                </div>

                            )
                        })}
                </div>



            </div>


            {/* Industries served */}

            <div className="bg-[#F8F6F6] w-full mt-[100px] py-[100px] font-noto font-semibold text-center px-2" id="industry-services" data-aos="fade-up">

                {/* Industries we serve */}

                <div>
                    <h1 className='heading'data-aos="fade-up">Industries We Serve</h1>
                    <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[25px]' data-aos="fade-up" data-aos-duration="800"/>
                </div>

                {/* Loop card */}

                <div className="max-w-[1070px] mx-auto flex flex-wrap justify-evenly gap-y-[40px] my-[85px]">
                    {
                        industries_serve.map((items) => {
                            return (
                                <Link className="mx-auto lg:mx-0" to={items.link} onClick={handleTop}>
                                    <div className="w-[322px] h-[200px] bg-white py-[50px] cursor-pointer duration-300 ease-in-out  hover:scale-110" >
                                        <img className="w-[50px] mx-auto" src={items.icon} alt={items.alt} />
                                        <h1 className="font-noto font-bold text-[22px] mt-[20px]">{items.heading}</h1>
                                    </div>
                                </Link>
                            )
                        })
                    }
                </div>

            </div>


            <Howitworks />

            <Tools />

            <TestimonialSlider />

            {/* <Testimonial /> */}

            <a href='https://www.google.com/search?sca_esv=0cc3b5bc5eb43f9c&si=AMgyJEvkVjFQtirYNBhM3ZJIRTaSJ6PxY6y1_6WZHGInbzDnMQrBjsHIRqCxxwTbPxUbJ4RMTn-S7H5ZS_OlrXE3HjAzhGXUfdnaJrezLduvGnb69kqo76JZmUEA-jPkDJw4eW3a1_LH&q=Lands+and+Lands+Reviews&sa=X&ved=2ahUKEwin4ZCY1LmPAxU6R2cHHVIaIpUQ0bkNegQIJhAE&biw=1504&bih=860&dpr=2' target="_blank" >
                <div className='flex-col justify-center text-center'>
                    <img className='w-[168px] mx-auto' src={google_logo} alt='Google_logo' data-aos="fade-up" />
                    <p className='text-[18px] text-[#575857] mt-[10px]' data-aos="fade-up" >Check out our Google reviews page <span className='text-[#FF0000]'> here.</span></p>
                </div>
            </a>

            <div className="max-w-[1200px] mx-auto bg-[#F8F6F6] py-[40px] px-[20px] my-[60px] md:py-[80px] md:px-[30px] md:my-[125px]" data-aos="fade-up">

                <div className="flex flex-wrap justify-between gap-8 xl:gap-0">

                    <div className="max-w-[480px] mx-auto">
                        <h1 className="font-noto text-[30px] font-bold sm:text-[34px] sm:leading-[49px]" data-aos="fade-up">Position Yourself in Coimbatore's Fastest-Growing Industrial Hubs</h1>
                        <p className="font-alibaba text-[18px] text-[#5F5D5E] leading-[28px] mt-[23px] mb-[60px]" data-aos="fade-up">The city’s new industry corridors are opening up high-return opportunities. We help you identify strategic sites, structure smart deals, and secure assets poised for long-term value. Move early, move right.</p>
                        <Button
                            name={"Schedule a Consultation"}
                            design={"filled"}
                            action={"modal-open"}
                            modalfunction={toggle}
                        />                
                        </div>

                    <img className="w-[530px] h-[406px] mx-auto" data-aos="fade-up" src={industrial_logistics} alt="Industrial Logistics" />
                </div>

            </div>

            {/* <Chatwithus /> */}
            <FormModal
                modal={modalToggle}
                active={toggle}
            />

        </>
    )
}

export default B2B;